// extracted by mini-css-extract-plugin
export default {"container":"CartMenuButton_container__2SLHe","cartLabel":"CartMenuButton_cartLabel__1ERUY","badge":"CartMenuButton_badge__7Eijs","loading":"CartMenuButton_loading__nB9Re"};